interface HeroSectionProps {
  onOpenApprovalModal: () => void;
}

export default function HeroSection({ onOpenApprovalModal }: HeroSectionProps) {
  return (
    <section className="relative min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden" id="hero">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20dashboard%20interface%20showing%20advertising%20analytics%2C%20customer%20behavior%20flow%20charts%2C%20WhatsApp%20and%20Instagram%20message%20panels%2C%20Meta%20ads%20performance%20data%2C%20AI%20analysis%20cards%20with%20glowing%20electric%20blue%20accent%20elements%2C%20dark%20navy%20blue%20color%20scheme%2C%20premium%20technology%20aesthetic%2C%20clean%20data%20visualization%2C%20abstract%20geometric%20patterns%2C%20futuristic%20professional%20corporate%20style%2C%20soft%20glow%20effects%2C%20minimalist%20design%20with%20depth%20and%20layered%20transparency&width=1600&height=900&seq=hero-dashboard-2026&orientation=landscape"
          alt="Readdy Davranış Analizi Destekli Reklam Sistemi Dashboard"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/70 via-primary-900/50 to-primary-900/80"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-500/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-accent-300 text-xs font-medium">Yapay Zeka Destekli Reklam & Davranış Analizi Sistemi</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          Klasik Reklam Ajansı Değil,
          <br />
          <span className="text-accent-400">Davranış Analizi</span> Destekli Reklam Sistemi
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-3xl mx-auto mb-4 leading-relaxed">
          Reklamdan gelen kişilerin sadece mesaj atıp atmadığını değil, gerçekten potansiyel müşteri olup olmadığını analiz eden, bu veriyi tekrar reklam sistemine geri döndüren özel bir yapı kuruyoruz.
        </p>

        <p className="text-sm md:text-base text-secondary-400 font-medium mb-8">
          Önce ücretsiz örnek sistemi görün. İşinize uygun bulursanız ilk ay sadece 5.000 TL başlangıç bedeliyle deneyin.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <a
            href="#nasil-calisir"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-search-eye-line"></i>
            Benim İçin Uygun mu İnceleyeyim
          </a>
          <button
            type="button"
            onClick={onOpenApprovalModal}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line text-lg"></i>
            WhatsApp'tan Uygundur Yaz
          </button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-3">
          {[
            { icon: 'ri-eye-line', text: 'Ücretsiz Ön İzleme' },
            { icon: 'ri-money-dollar-circle-line', text: 'İlk Ay 5.000 TL' },
            { icon: 'ri-shield-check-line', text: 'Taahhüt Yok' },
            { icon: 'ri-robot-2-line', text: 'Reklam + Otomasyon + Panel' },
            { icon: 'ri-bar-chart-grouped-line', text: 'Davranış Analizi' },
          ].map((badge) => (
            <div
              key={badge.text}
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/15 text-background-50/90 text-xs font-medium whitespace-nowrap"
            >
              <i className={`${badge.icon} text-accent-400`}></i>
              {badge.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}